import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
    //首页
    {
        path: '/',
        name: 'totalPage',
        component: () =>
            import ('../views/totalPage.vue')
    },
    // {
    //     path: '/uat',
    //     name: 'uatTotalPage',
    //     component: () =>
    //         import ('../views/totalPage.vue')
    // },
    // //个人主页
    // {
    //     path: '/home',
    //     name: 'home',
    //     component: HomeView
    // },
    // {
    //     path: '/about',
    //     name: 'about',
    //     component: () =>
    //         import ('../views/AboutView.vue')
    // },
    // //问题详情
    // {
    //     path: '/quizDetails',
    //     name: 'quizDetails',
    //     component: () =>
    //         import ('../views/quizDetails.vue')
    // },
    // // 关注动态
    // {
    //     path: '/AttentionDynamic',
    //     name: 'AttentionDynamic',
    //     component: () =>
    //         import ('../views/AttentionDynamic.vue')
    // },
    // //结束会议
    // {
    //     path: '/endMeeting',
    //     name: 'endMeeting',
    //     component: () =>
    //         import ('../views/endMeeting.vue')
    // },
    // //正在进行中/未开始的会议
    // {
    //     path: '/underwayMeeting',
    //     name: 'underwayMeeting',
    //     component: () =>
    //         import ('../views/underwayMeeting.vue')
    // },
    //下载页面
    {
        path: '/downloadPage',
        name: 'downloadPage',
        component: () =>
            import ('../views/downloadPage/downloadPage.vue')
    },
    // 智能解答下载页
    {
        path: '/smartAnswerDownloadPage',
        name: 'smartAnswerDownloadPage',
        component: () =>
            import ('../views/smartAnswerDownloadPage/smartAnswerDownloadPage.vue')
    },
    // 在报道中提到了你(凡文)
    {
        path: '/mentionYou',
        name: 'mentionYou',
        component: () =>
            import ('../views/mentionYou/mentionYou.vue')
    },
     // 提交了报道
     {
        path: '/submitReport',
        name: 'submitReport',
        component: () =>
            import ('../views/submitReport/submitReport.vue')
    },
    // 通稿、帖子
    {
        path: '/wireCopyPost',
        name: 'wireCopyPost',
        component: () =>
            import ('../views/wireCopyPost/wireCopyPost.vue')
    },
    //----------------一下为测试环境路由
    //下载页面
    // {
    //     path: '/uat/downloadPage',
    //     name: 'uatDownloadPage',
    //     component: () =>
    //         import ('../views/downloadPage/downloadPage.vue')
    // },
    // // 智能解答下载页
    // {
    //     path: '/uat/smartAnswerDownloadPage',
    //     name: 'uatSmartAnswerDownloadPage',
    //     component: () =>
    //         import ('../views/smartAnswerDownloadPage/smartAnswerDownloadPage.vue')
    // },
    // // 在报道中提到了你(凡文)
    // {
    //     path: '/uat/mentionYou',
    //     name: 'uatMentionYou',
    //     component: () =>
    //         import ('../views/mentionYou/mentionYou.vue')
    // },
    //  // 提交了报道
    //  {
    //     path: '/uat/submitReport',
    //     name: 'uatSubmitReport',
    //     component: () =>
    //         import ('../views/submitReport/submitReport.vue')
    // },
    // // 通稿、帖子
    // {
    //     path: '/uat/wireCopyPost',
    //     name: 'uatWireCopyPostUat',
    //     component: () =>
    //         import ('../views/wireCopyPost/wireCopyPost.vue')
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router